import {
  FilePdfOutlined,
  FileWordOutlined,
  FilePptOutlined,
  FileExcelOutlined,
  FileTextOutlined,
  FileZipOutlined,
  FileImageOutlined,
} from '@ant-design/icons';

/**
 * Returns the appropriate icon component based on file type
 * @param file - File object to determine icon for
 * @returns React icon component with file-item__format-icon className
 */

type AttachmentType = {
  size: number;
  type: string;
  url: string;
  name: string;
}

export const getFileIcon = (file: File | AttachmentType) => {
  const type = file.type;
  const name = file.name.toLowerCase();

  // PDF files
  if (type === 'application/pdf') {
    return <FilePdfOutlined className="file-item__format-icon" />;
  }

  // Word documents
  if (type.includes('word') || name.endsWith('.doc') || name.endsWith('.docx')) {
    return <FileWordOutlined className="file-item__format-icon" />;
  }

  // PowerPoint presentations
  if (type.includes('powerpoint') || name.endsWith('.ppt') || name.endsWith('.pptx')) {
    return <FilePptOutlined className="file-item__format-icon" />;
  }

  // Excel spreadsheets
  if (type.includes('excel') || name.endsWith('.xls') || name.endsWith('.xlsx')) {
    return <FileExcelOutlined className="file-item__format-icon" />;
  }

  // Plain text files
  if (type === 'text/plain') {
    return <FileTextOutlined className="file-item__format-icon" />;
  }

  // Archive files (zip, rar)
  if (type.includes('zip') || type.includes('rar')) {
    return <FileZipOutlined className="file-item__format-icon" />;
  }

  // Default icon for other file types (primarily images)
  return <FileImageOutlined className="file-item__format-icon" />;
};
